import { useSearchParams } from 'react-router-dom'

const useSearchParamValue = (key, defaultValue) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const param = searchParams.get(key)
  const value = param || param === '' ? param : defaultValue

  const setValue = (newValue) => {
    const next = new URLSearchParams(window.location.search)
    next.set(key, newValue)
    setSearchParams(next, { replace: true })
  }

  const removeParam = () => {
    const next = new URLSearchParams(window.location.search)
    next.delete(key)
    setSearchParams(next, { replace: true })
  }

  return [value, setValue, removeParam]
}

export default useSearchParamValue
